
























import { Component, Prop } from 'vue-property-decorator';

import { ValidationMessageCpt, BaseInputComponent } from '.';
import { SetNumberInputIdDirective, SetNumberButtonsAccessibilityDirective } from '@/core/directives';

@Component({
  components: {
    ValidationMessageCpt,
  },
  directives: {
    setInputId: SetNumberInputIdDirective,
    setButtonsAccessibility: SetNumberButtonsAccessibilityDirective,
  },
})
export default class InputNumberCpt extends BaseInputComponent {
  @Prop() min?: number;
  @Prop() max?: number;
  @Prop() controls?: boolean;

  @Prop() inputId?: string;

  get internalInputId() {
    return !this.inputId ? this.prop : this.inputId;
  }
}
